import LAYOUT from '@/layout/layout';
import moduleLayout from '@/modules/FastLine/layout/Layout.vue';

export default [
  {
    path: '/fastline/',
    component: LAYOUT.base,
		name: 'FastLine',
    redirect: {name: 'FastLineSection'},
    children: [
      {
        path: '',
        component: moduleLayout,
        children: [
          {
            path: ':id/section',
            name: 'FastLineSection',
            component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLine/views/FastLine.vue'),
          },
        ],
      },
    ],
  },
];
